import type { MarketVariants } from '@/lib/i18n'

export type Slide3SecrecyCopy = {
  heading: string
  body1: string
  body2: string
  body3: string
}

// Canonical US copy. "organizations" auto-spells to "organisations" on the
// Qatar face via useSlideCopy.
export const copy: MarketVariants<Slide3SecrecyCopy> = {
  US: {
    heading: 'Demands for secrecy',
    body1:
      'Scammers need to keep you away from the people who would tell you to stop. Romance scammers call it privacy. Investment scammers call it exclusivity. Impersonators call it confidentiality.',
    body2: 'Real organizations encourage you to consult trusted advisors.',
    body3:
      'If someone tells you not to discuss something with your family or friends, that is exactly when you should.',
  },
  ar: {
    heading: 'المطالبة بالسرية',
    body1:
      'يحتاج المحتالون إلى إبعادك عن الأشخاص الذين قد ينصحونك بالتوقف. محتالو العلاقات العاطفية يسمّونها خصوصية. ومحتالو الاستثمار يسمّونها حصرية. ومنتحلو الشخصيات يسمّونها سرّية تامة.',
    body2: 'الجهات الحقيقية تشجّعك على استشارة من تثق بهم.',
    body3:
      'إذا طلب منك أحد ألا تناقش أمراً ما مع عائلتك أو أصدقائك، فهذا بالضبط هو الوقت الذي يجب أن تفعل فيه ذلك.',
  },
}
